module.exports = __webpack_public_path__ + "static/media/info-keypoint3button.854607d9.png";